<template>
  <page>
    <v-card>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.shortTermPct" :label="labels.shortTermPct" :error-messages="errors.collect('shortTermPct')" data-vv-name="shortTermPct" :data-vv-as="labels.shortTermPct" v-validate="'mask_max_value:100'" v-num-mask="{negative: true, intScale: 3, decScale: 2}"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-autocomplete :label="labels.appDayMth" :items="appDayMthList" v-model="filters.appDayMth" item-text="value" item-value="code" data-vv-name="appDayMth" :data-vv-as="labels.appDayMth" :error-messages="errors.collect('appDayMth')"></v-autocomplete>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.noDayMth" :label="labels.noDayMth" :error-messages="errors.collect('noDayMth')" data-vv-name="noDayMth" :data-vv-as="labels.noDayMth" v-validate="noDayMthValidtion"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.polType" :label="labels.polType" :error-messages="errors.collect('polType')" data-vv-name="polType" :data-vv-as="labels.polType" v-validate="'entry|param|max:4'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <div>
              <v-btn color="primary" dark class=" mr-2" @click="doNew">
                New Short Term Rate
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.shortTermPct }}</td>
                <td class="text-xs-left">{{ row.item.appDayMth }}</td>
                <td class="text-xs-left">{{ row.item.noDayMth }}</td>
                <td class="text-xs-left">{{ row.item.polType }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)" query @query="doQuery(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the Short Term Rate?</p>
          <div class="queryValue">{{selectedShortTermRate.polType}} , {{selectedShortTermRate.appDayMth}}, {{selectedShortTermRate.noDayMth}}</div>
    </confirm>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatPrice } from '@/utils/index'
import clone from 'clone'
export default {
  data() {
    return {
      promptRemove: false,
      toogleArray: [false],
      headers: [
        { text: '%', value: 'shortTermPct' },
        { text: 'Apply Day / Month', value: 'appDayMth' },
        { text: 'No. Days / Months', value: 'noDayMth' },
        { text: 'Policy Type', value: 'polType' },
        TableConst.tableActionHeader
      ],
      labels: {
        shortTermPct: 'Rate',
        appDayMth: 'Apply Day / Month',
        noDayMth: 'No. Days / Months',
        polType: 'Policy Type'
      },
      filters: {
        shortTermPct: undefined,
        appDayMth: undefined,
        noDayMth: undefined,
        polType: undefined
      },
      appDayMthList: [
        { code: 'M', value: 'Months' },
        { code: 'D', value: 'Days' }
      ],
      selectedShortTermRate: {
        polType: null,
        appDayMth: null,
        noDayMth: null
      },
      totalItems: 0,
      loading: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  created() {
    this.doInit(true)

    this.$validator.extend('valNoMth', {
      getMessage(field, args) {
        return 'Month cannot exceed 12'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var noDayMth = args[0]
        if (noDayMth) {
          if (parseInt(value) > noDayMth) {
            return false
          } else {
            return true
          }
        }
      }
    })

    this.$validator.extend('valNoDay', {
      getMessage(field, args) {
        return 'Day cannot exceed 366'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var noDayMth = args[0]
        if (noDayMth) {
          if (parseInt(value) > noDayMth) {
            return false
          } else {
            return true
          }
        }
      }
    })
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.shortTermRateList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let cloneFilter = clone(this.filters)
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), cloneFilter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  shortTermPct: formatPrice(datamap.shortTermPct),
                  appDayMth: datamap.appDayMth,
                  noDayMth: datamap.noDayMth,
                  polType: datamap.polType,
                  createdName: datamap.createdName,
                  createdDate: datamap.createdDate,
                  modifiedName: datamap.modifiedName,
                  modifiedDate: datamap.modifiedDate
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.shortTermPct = undefined
      this.filters.appDayMth = undefined
      this.filters.noDayMth = undefined
      this.filters.polType = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doNew() {
      const commit = {
        shortTermPct: null,
        appDayMth: null,
        noDayMth: null,
        polType: null,
        createdName: null,
        createdDate: null,
        modifiedName: null,
        modifiedDate: null,
        strMode: 'New'
      }
      sessionStorage.setItem('shrtTrmRate', JSON.stringify(commit))
      this.$store.commit('SHORTTERMRATE_COMMIT_KEY', commit)
      this.$router.push({ name: 'shrtTrmRateDetail' })
    },
    doReview(data) {
      const commit = {
        shortTermPct: data.shortTermPct,
        appDayMth: data.appDayMth,
        noDayMth: data.noDayMth,
        polType: data.polType,
        createdName: data.createdName,
        createdDate: data.createdDate,
        modifiedName: data.modifiedName,
        modifiedDate: data.modifiedDate,
        strMode: 'Review'
      }
      sessionStorage.setItem('shrtTrmRate', JSON.stringify(commit))
      this.$store.commit('SHORTTERMRATE_COMMIT_KEY', commit)
      this.$router.push({ name: 'shrtTrmRateDetail' })
    },
    doQuery(data) {
      const commit = {
        shortTermPct: data.shortTermPct,
        appDayMth: data.appDayMth,
        noDayMth: data.noDayMth,
        polType: data.polType,
        createdName: data.createdName,
        createdDate: data.createdDate,
        modifiedName: data.modifiedName,
        modifiedDate: data.modifiedDate,
        strMode: 'Query'
      }
      sessionStorage.setItem('shrtTrmRate', JSON.stringify(commit))
      this.$store.commit('SHORTTERMRATE_COMMIT_KEY', commit)
      this.$router.push({ name: 'shrtTrmRateDetail' })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeleteShortTermRate
          const expand = {
            polType: data.polType,
            appDayMth: data.appDayMth,
            noDayMth: data.noDayMth
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selectedShortTermRate.polType = data.polType
          this.selectedShortTermRate.appDayMth = data.appDayMth
          this.selectedShortTermRate.noDayMth = data.noDayMth
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedShortTermRate) {
        const apiURI = this.menu.deleteShortTermRate
        if (apiURI) {
          const expand = {
            polType: this.selectedShortTermRate.polType,
            appDayMth: this.selectedShortTermRate.appDayMth,
            noDayMth: this.selectedShortTermRate.noDayMth
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit(true)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.shortTermRateParam.menu
    },
    noDayMthValidtion() {
      if (this.filters.appDayMth === 'M') {
        return 'valNoMth:' + '12'
      } else {
        return 'valNoDay:' + '366'
      }
    }
  },
  components: {},
  mixins: [TableConst.default, MessageMixin]
}
</script>
